import { create } from 'zustand';
import { MessageUI } from '@/api/messaging/types.ts';

interface MessagesStore {
  inputMessages: Record<string, string>;
  replyToMessage: Record<string, MessageUI | null>;
  saveInputMessage: (contactHid: string | undefined, message: string) => void;
  clearInputMessage: (contactHid: string | undefined) => void;
  clearAllInputMessages: () => void;
  setReplyToMessage: (contactHid: string, message: MessageUI | null) => void;
  clearReplyToMessage: (contactHid: string) => void;
}

export const useMessagesStore = create<MessagesStore>((set) => ({
  inputMessages: {},
  replyToMessage: {},
  saveInputMessage: (contactHid, message) =>
    set((state) => {
      if (!contactHid) return state; // Skip if no contactHid
      return {
        inputMessages: {
          ...state.inputMessages,
          [contactHid]: message
        }
      };
    }),
  clearInputMessage: (contactHid) =>
    set((state) => {
      if (!contactHid) return state;
      const { [contactHid]: _, ...rest } = state.inputMessages;
      return { inputMessages: rest };
    }),
  clearAllInputMessages: () =>
    set({
      inputMessages: {}
    }),
  setReplyToMessage: (contactHid, message) =>
    set((state) => ({
      replyToMessage: {
        ...state.replyToMessage,
        [contactHid]: message
      }
    })),
  clearReplyToMessage: (contactHid) =>
    set((state) => ({
      replyToMessage: {
        ...state.replyToMessage,
        [contactHid]: null
      }
    }))
}));
